import { render, staticRenderFns } from "./SidebarNewsTeaser.vue?vue&type=template&id=6148c850&scoped=true&"
import script from "./SidebarNewsTeaser.vue?vue&type=script&lang=js&"
export * from "./SidebarNewsTeaser.vue?vue&type=script&lang=js&"
import style0 from "./SidebarNewsTeaser.vue?vue&type=style&index=0&id=6148c850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6148c850",
  null
  
)

export default component.exports